import { AUTH_CALLBACK_PATH, AuthProvider, sanitizeReturnTo } from '@frontend/auth';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { env } from './lib/env';
import { router } from './routes';
import './styles/globals.css';

const rootElement = document.querySelector('#root');
if (!rootElement) throw new Error('Root element #root not found in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider
      config={{
        domain: env.VITE_AUTH0_DOMAIN,
        clientId: env.VITE_AUTH0_CLIENT_ID,
        redirectUri: globalThis.location.origin + AUTH_CALLBACK_PATH,
        audience: env.VITE_AUTH0_AUDIENCE,
      }}
      // Restores the guard-captured path once the callback exchange lands.
      // sanitizeReturnTo is defense-in-depth here: appState is untrusted (it
      // round-trips through Auth0), so re-validate rather than trust it.
      onRedirectCallback={(appState) => {
        void router.navigate(sanitizeReturnTo(appState?.returnTo), { replace: true });
      }}
    >
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
